import React, { useState } from 'react';
// import {Alert} from "antd"
import 'antd/dist/antd.css';
import { Button } from 'antd';
// import {store} from "../redux/store"
import { useSelector } from "react-redux"
function Result() {

  const [score, setScore] = useState("")
   const stateeee=useSelector(state=>state.ourState.score)
  const watchScore = () => {
    // setScore("5")

    // console.log("state",score)
    setScore(stateeee)
  }
  return (
    <> <div >
      <div style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: 'center', alignItems: "center", marginTop: "20px"
      }}>
        <div>
          <Button onClick={watchScore}
            type="primary" htmlType="submit">
            Click to see score
          </Button>
        </div>

        <div >
          <p style={{ textAlign:"center",padding:"20px",color:"white", height: "70px", marginTop: "20px", width: "70px", borderRadius: "50%", backgroundColor: "#1890ff" }}>{score}</p>
        </div>
      </div>

    </div>


    </>)
    ;
}
// const mapStateToProps = (state) => {
//   return{
//       score:state.ourState.score,

//   }
// }
// const mapDispatchToProps = (dispatch) => {
  
// }


// export default connect(mapStateToProps,mapDispatchToProps)(Result)

export default Result;
